import { isEmpty } from 'lodash';
import useLocationInformationById from './useLocationInformationByLocationId';
import useLocationInformationBySlug from './useLocationInformationBySlug';

export default function useLocationInformation() {
  const locationById = useLocationInformationById();
  const locationBySlug = useLocationInformationBySlug();

  if (isEmpty(locationById) && isEmpty(locationBySlug)) {
    window.location = '/online-ordering';
    throw new Error(
      'Location information not found from useLocationInformation'
    );
  }

  return locationById || locationBySlug;
}
